import React, {Component, useState, useEffect} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom';
import BlogInfoContent from '../components/BlogInfoContent'; 
import axios from 'axios'; 
import Header from '../common/Header'; 
import Footer from '../common/Footer';
import PageHeader from '../components/PageHeader'; 
import ExploreMore from '../components/ExploreMore'; 
import GetInTouch from '../components/GetInTouch'; 
import withRouter from '../components/withRouter';
import {api_base_url, base_url} from '../common/Constants'; 
import { Helmet } from "react-helmet";

class BlogInfo extends React.Component{

    constructor(props){
           super(props);
   
           
           this.state = {
               blog : [],
               loading : 1 
           }
       }
       componentDidMount()
       {
           var data = { id : this.props.params.id} 
               axios.post(api_base_url+"blog", data).then(response=>{
                   this.setState({blog:response.data}); 
                   this.setState({loading:0});
               }); 
       }

    componentDidUpdate(prevProps)
    {
        var data = { id : this.props.params.id}
        if (this.props.params.id !== prevProps.id)
        {
            axios.post(api_base_url+"blog", data).then(response=>{
                this.setState({blog:response.data}); 
                this.setState({loading:0});
            });
        }
    }
 
    render()
    { 
        const content = JSON.parse(localStorage.getItem("content"));
        const metas = JSON.parse(localStorage.getItem("metas"));

        return (
            <div className='bodyblock'>
            <div data-v-8e945784="" data-v-e8f34808="" class="page-block sub-articles">
                <Header/> 
                <Helmet>
                    <title>{"Blog - "+this.state.blog.title+" - "+metas[0].title}</title>  
                    <meta name="description" content={this.state.blog.meta_description} />
                    <meta name="keywords" content={this.state.blog.meta_title} />
                    <meta property="og:image" content={this.state.blog.image}  />
                    <link rel="canonical" href={base_url+'blog-info/'+this.state.blog.slug} />
                </Helmet>
                <PageHeader title={this.state.blog.title}   main_title="News & Updates"  blog={this.state.blog}  banner={this.state.blog.image} />
                <BlogInfoContent  content={JSON.parse(localStorage.getItem("content"))}  blog={this.state.blog} blogs={JSON.parse(localStorage.getItem("blogs"))}  />  
                  <ExploreMore content={JSON.parse(localStorage.getItem("content"))}/>  
                <GetInTouch content={JSON.parse(localStorage.getItem("content"))}/>  
                <Footer/>
            
       </div></div>
        )
    }

}
export default withRouter(BlogInfo);;